import { render, staticRenderFns } from "./locus.vue?vue&type=template&id=ed307144&scoped=true&"
import script from "./locus.vue?vue&type=script&lang=js&"
export * from "./locus.vue?vue&type=script&lang=js&"
import style0 from "./locus.vue?vue&type=style&index=0&id=ed307144&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed307144",
  null
  
)

export default component.exports